import {procUndeleteSaved, procDeleteSaved, procDisplaySaved} from '../services/savedReports';
import {displayMode} from '../consts/savedReports';

export async function toggleAllowDeletion(type: string, ename: string, name: string) {
    const result: any = await procUndeleteSaved(type, ename, name);
    return result?.Procedure?.[0]?.Saved?.[0]?.nodelete === '1';
}

export function deleteSavedReport(type: string, ename: string, name: string) {
    procDeleteSaved(type, ename, name);
}

export async function displaySavedReport(type: string, ename: string, name: string) {
    procDisplaySaved(type, ename, name, displayMode.display);
}

export async function sendSavedReport(type: string, ename: string, name: string) {
    procDisplaySaved(type, ename, name, displayMode.send);
}
